import ErrorUtils from 'utils/error-utils';
import SegmentUtils from 'utils/segment';
import getReservationStatus from 'segment/utils/reservation-status';
import UserUtils from 'utils/user-utils';
import dayjs from 'utils/dayjs-timezone';

export default function trackReservationTimesAdjustmentFailed({
    reservation,
    rateDiff,
    reservationPriceChanged,
    activeStatus,
    user,
    errorMessage,
}) {
    try {
        const {
            reservationType,
            currencyType,
            rentalId,
            entryTimestamp,
            paymentStatus,
            partner,
            parkingPassType,
            starts,
            ends,
        } = reservation;
        const {status} = user;
        const reservationStatus = getReservationStatus({
            activeStatus,
            paymentStatus,
        });

        const startsDiff = dayjs(rateDiff.starts).diff(starts, 'minute');
        const endsDiff = dayjs(rateDiff.ends).diff(ends, 'minute');
        let adjustment = 'moved';

        // if starts is after original starts and ends is before or same as original ends
        if (
            (startsDiff > 0 && endsDiff <= 0) ||
            (startsDiff >= 0 && endsDiff < 0)
        ) {
            adjustment = 'shortened';
        } else if (
            (startsDiff < 0 && endsDiff >= 0) ||
            (startsDiff <= 0 && endsDiff > 0)
        ) {
            adjustment = 'extended';
        }

        const properties = {
            error: errorMessage,
            adjustment,
            start_change: startsDiff,
            end_change: endsDiff,
            parking_type: reservationType,
            scanned_in_time: entryTimestamp,
            reservation_status: reservationStatus,
            partner: partner?.slug || null,
            currency: currencyType.toLowerCase(),
            rental_id: rentalId,
            price_difference: reservationPriceChanged,
            user_logged_in: status === UserUtils.AUTH_STATE.USER,
            parking_pass_type: parkingPassType,
        };

        SegmentUtils.track({
            event: 'Reservation Times Adjustment Failed',
            properties,
            additionalOptions: {
                context: {
                    protocols: {
                        event_version: 1,
                    },
                },
            },
        });
    } catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage:
                'Segment Event Failed - trackReservationTimesAdjustmentFailed',
        });
    }
}
